import React, { useState } from 'react';
import { ArrowLeftIcon, FilterIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';
// Generate time slots from 8 AM to 2 AM (next day)
const generateTimeSlots = (isFriday: boolean = false) => {
  const slots = [];
  // 8 AM to 11 AM
  for (let hour = 8; hour <= 11; hour++) {
    slots.push({
      time: `${hour}:00 AM`,
      available: true,
      priceUC: 15,
      price: 15
    });
  }
  // 12 PM to 2 PM - Friday prayer closure
  if (isFriday) {
    slots.push({
      time: '12:00 PM',
      available: false,
      priceUC: 15,
      price: 15,
      reason: 'Friday Prayer'
    });
    slots.push({
      time: '1:00 PM',
      available: false,
      priceUC: 15,
      price: 15,
      reason: 'Friday Prayer'
    });
  } else {
    slots.push({
      time: '12:00 PM',
      available: true,
      priceUC: 20,
      price: 20
    });
    slots.push({
      time: '1:00 PM',
      available: true,
      priceUC: 20,
      price: 20
    });
  }
  // 2 PM to 11 PM
  for (let hour = 2; hour <= 11; hour++) {
    slots.push({
      time: `${hour}:00 PM`,
      available: true,
      priceUC: 20,
      price: 20
    });
  }
  // 12 AM to 2 AM (next day)
  slots.push({
    time: '12:00 AM',
    available: true,
    priceUC: 15,
    price: 15
  });
  slots.push({
    time: '1:00 AM',
    available: true,
    priceUC: 15,
    price: 15
  });
  slots.push({
    time: '2:00 AM',
    available: true,
    priceUC: 15,
    price: 15
  });
  return slots;
};
// All 6 courts matching HomeScreen
const allCourts = [{
  id: 'court-1',
  name: 'Court 1',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
  surface: 'Premium Padel',
  type: 'Indoor'
}, {
  id: 'court-2',
  name: 'Court 2',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
  surface: 'Premium Padel',
  type: 'Indoor'
}, {
  id: 'court-3',
  name: 'Court 3',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
  surface: 'Standard Padel',
  type: 'Indoor'
}, {
  id: 'court-4',
  name: 'Court 4',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
  surface: 'Standard Padel',
  type: 'Indoor'
}, {
  id: 'court-5',
  name: 'Court 5',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
  surface: 'Pickleball',
  type: 'Indoor'
}, {
  id: 'court-6',
  name: 'Court 6',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
  surface: 'Pickleball',
  type: 'Indoor'
}];
export function CalendarScreen() {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(22);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);
  const days = Array.from({
    length: 30
  }, (_, i) => i + 1);
  // Check if selected date is Friday (Nov 22, 2024 is a Friday for example)
  const isFriday = selectedDate === 22;
  const timeSlots = generateTimeSlots(isFriday);
  return <div className="h-screen w-full flex flex-col bg-[#f8f9fa]" data-id="element-421">
      {/* Header */}
      <div className="bg-white px-4 py-4 flex items-center justify-between shadow-sm" data-id="element-422">
        <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-423">
          <ArrowLeftIcon className="w-6 h-6 text-[#1f5070]" data-id="element-424" />
        </button>
        <h1 className="text-xl font-bold text-[#1f5070]" data-id="element-425">Select Date & Time</h1>
        <button className="p-2 hover:bg-gray-100 rounded-full" data-id="element-426">
          <FilterIcon className="w-6 h-6 text-[#1f5070]" data-id="element-427" />
        </button>
      </div>

      <div className="flex-1 overflow-auto pb-24" data-id="element-428">
        {/* Month Header */}
        <div className="bg-white px-6 py-4 flex items-center justify-between" data-id="element-429">
          <button className="p-2 hover:bg-gray-100 rounded-full" data-id="element-430">
            <ChevronLeftIcon className="w-6 h-6 text-[#1f5070]" data-id="element-431" />
          </button>
          <h2 className="text-lg font-bold text-[#1f5070]" data-id="element-432">November 2024</h2>
          <button className="p-2 hover:bg-gray-100 rounded-full" data-id="element-433">
            <ChevronRightIcon className="w-6 h-6 text-[#1f5070]" data-id="element-434" />
          </button>
        </div>

        {/* Calendar Grid */}
        <div className="bg-white px-6 py-4 mb-4" data-id="element-435">
          <div className="grid grid-cols-7 gap-2 mb-2" data-id="element-436">
            {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(day => <div key={day} className="text-center text-sm font-bold text-[#666666]" data-id="element-437">
                {day}
              </div>)}
          </div>
          <div className="grid grid-cols-7 gap-2" data-id="element-438">
            {days.map(day => {
            const isToday = day === 21;
            const isSelected = day === selectedDate;
            const hasAvailability = day >= 21 && day <= 28;
            return <button key={day} onClick={() => hasAvailability && setSelectedDate(day)} disabled={!hasAvailability} className={`aspect-square rounded-lg flex flex-col items-center justify-center text-sm font-bold transition-all ${isSelected ? 'bg-[#3dc7e3] text-white' : isToday ? 'border-2 border-[#3dc7e3] text-[#1f5070]' : hasAvailability ? 'text-[#1f5070] hover:bg-gray-100' : 'text-gray-300'}`} data-id="element-439">
                  {day}
                  {hasAvailability && !isSelected && <div className="w-1 h-1 bg-[#c7f61e] rounded-full mt-1" data-id="element-440"></div>}
                </button>;
          })}
          </div>
        </div>

        {/* Time Slots */}
        <div className="px-6 py-4" data-id="element-441">
          <h3 className="text-lg font-bold text-[#1f5070] mb-4" data-id="element-442">
            Available Times
          </h3>
          {isFriday && <div className="mb-3 p-3 bg-[#FFF3E0] border-l-4 border-[#FF9800] rounded" data-id="element-443">
              <p className="text-sm text-[#E65100] font-medium" data-id="element-444">
                ⚠️ Courts closed 12:00 PM - 2:00 PM for Friday Prayer
              </p>
            </div>}
          <div className="flex gap-3 overflow-x-auto pb-4 pr-4 scrollbar-hide" data-id="element-445">
            {timeSlots.map(slot => <button key={slot.time} onClick={() => slot.available && setSelectedTime(slot.time)} disabled={!slot.available} className={`flex-shrink-0 px-4 py-3 rounded-lg border-2 transition-all ${selectedTime === slot.time ? 'bg-[#3dc7e3] border-[#3dc7e3] text-white' : slot.available ? 'bg-white border-[#3dc7e3] text-[#1f5070] hover:bg-[#3dc7e3]/10' : 'bg-gray-100 border-gray-300 text-gray-400'}`} data-id="element-446">
                <div className="text-sm font-bold whitespace-nowrap" data-id="element-447">
                  {slot.time}
                </div>
                {slot.available ? <div className={`text-xs mt-1 ${selectedTime === slot.time ? 'text-white' : 'text-[#3dc7e3]'}`} data-id="element-448">
                    {slot.priceUC} UC
                  </div> : <div className="text-xs mt-1 text-gray-400" data-id="element-449">
                    {(slot as any).reason || 'Booked'}
                  </div>}
              </button>)}
          </div>
        </div>

        {/* Court Selector Preview - All 6 Courts */}
        {selectedTime && <div className="px-6 py-4 animate-slide-up" data-id="element-450">
            <h3 className="text-lg font-bold text-[#1f5070] mb-3" data-id="element-451">
              Available Courts
            </h3>
            <div className="space-y-3 pb-4" data-id="element-452">
              {allCourts.map(court => <button key={court.id} onClick={() => navigate(`/court/detail/${court.id}`)} className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-4 active:scale-98 transition-transform" data-id="element-453">
                  <img src={court.image} alt={court.name} className="w-16 h-16 rounded-lg object-cover" data-id="element-454" />
                  <div className="flex-1 text-left" data-id="element-455">
                    <h4 className="text-base font-bold text-[#1f5070]" data-id="element-456">
                      {court.name}
                    </h4>
                    <p className="text-sm text-[#666666]" data-id="element-457">
                      {court.surface} • {court.type}
                    </p>
                  </div>
                  <div className="text-right" data-id="element-458">
                    <div className="text-base font-bold text-[#3dc7e3]" data-id="element-459">
                      15 UC
                    </div>
                    <div className="text-xs text-[#666666]" data-id="element-460">$15</div>
                  </div>
                </button>)}
            </div>
          </div>}
      </div>

      {/* Bottom Button */}
      {selectedTime && <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-lg" data-id="element-461">
          <Button variant="primary" fullWidth onClick={() => navigate('/booking/cart')} data-id="element-462">
            Add to Booking
          </Button>
        </div>}
    </div>;
}